<div class="input-group mb-3">
  <input
    type="text"
    class="form-control"
    placeholder="ახალი საქაღალდის სახელი"
    [(ngModel)]="folderName"
  />
  <button class="btn btn-primary" (click)="createFolder()">შექმნა</button>
</div>
